import { isTextNode } from 'anodum';
import normalizeCollapsedSelection from '../normalize-collapsed-selection';
import splitTextByOffset from '../split-text-by-offset';
import splitSiblings from '../split-siblings';

const splitElement = (rootElementToSplit, selectionData) => {
  const { node, offset } = normalizeCollapsedSelection(selectionData);
  if (isTextNode(node)) {
    const [leftText, rightText] = splitTextByOffset(node, offset);
    node.nodeValue = rightText;

    const { ownerDocument: liveDocument } = node;
    const leftTextNode = liveDocument.createTextNode(leftText);
    return splitSiblings(rootElementToSplit, node, leftTextNode);
  }
  return splitSiblings(rootElementToSplit, node, node.cloneNode(true));
};

export default splitElement;
